import LogRocket from 'logrocket';

let initialized = false;

/**
 * Initialize LogRocket if not already initialized
 * This is called after successful authentication
 */
export function initLogRocket() {
  if (!initialized) {
    LogRocket.init('gbh1b3/bz');
    initialized = true;
    console.log('LogRocket initialized');
  }
}

/**
 * Identify user in LogRocket
 * Automatically initializes LogRocket if not already done
 */
export function identifyUser(username, userData = {}) {
  initLogRocket();
  
  LogRocket.identify(username, {
    name: userData.name || username,
    email: userData.email || username,
    ...userData
  });
  
  console.log('LogRocket user identified:', username);
}

/**
 * Check if LogRocket is initialized
 */
export function isLogRocketInitialized() {
  return initialized;
}

